<div class="header-mini">
    <div class="container">
        <app-back-link
            [text]="wts.getI18nLabel(i18nBasePath, 'links.backLink.text')"
            [showLeaveConfirmation]="true"
            (backEvent)="showLeaveConfirmationModal = true"></app-back-link>

        <app-confirm-modal
            *ngIf="showLeaveConfirmationModal"
            [confirmBtnDanger]="false"
            [cancelBtnText]="wts.getI18nLabel(i18nBasePath, 'links.backLink.confirmation.cancelBtnText')"
            [confirmBtnText]="wts.getI18nLabel(i18nBasePath, 'links.backLink.confirmation.confirmBtnText')"
            (cancel)="showLeaveConfirmationModal = false"
            (confirm)="onConfirm()">
            <span
                modalTitle
                [innerHTML]="wts.getI18nLabel(i18nBasePath, 'links.backLink.confirmation.title') | sanitizeHtml"></span>
            <span
                modalContent
                [innerHTML]="wts.getI18nLabel(i18nBasePath, 'links.backLink.confirmation.text') | sanitizeHtml"></span>
        </app-confirm-modal>
    </div>
</div>

<router-outlet></router-outlet>
